import React, { Component } from 'react';

import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Row, Col, Card, Button, Progress } from 'reactstrap';

//Componentes auxiliares:
import FileDetailBlock from './FileDetailBlock';
import ProcessTimeline from './ProcessTimeline';
import ElapsedTimeLabel from './ElapsedTimeLabel';
import CustomModal from '../../../tools/components/CustomModal';
import FileButton from '../../processesRegistry/auxiliars/FileButton';

//Scripts auxiliares:
import { getNumberAsWord } from '../../../tools/formatters/spellingFormatter';
import { getSourceTitleText, getSourceSubtitleText } from '../../../views/common/downloadSourcesRenderingFunctions';
let dateFormatter = require('../../../tools/formatters/dateFormatter');

//Estilos base:
let paragraphBaseStyle = { fontSize: "1.15em", textTransform: "none" };
let oneLineParagraphBaseStyle = { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" };

class ButtonWithStatusModal extends Component {

    constructor() {
        super();

        this.state = {
            filesDetail: [],
            processDetail: [],
            isTheModalOpen: false,
        }
    }

    componentDidMount() {
        this.updateProcessInfo();
    }

    render() {
        return (
            <React.Fragment>
                <div onClick={this.modalToggle} style={{ cursor: "pointer", alignSelf: "center" }}>
                    {this.props.children}
                </div>

                {this.getStatusDetailModal()}
            </React.Fragment>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            if (prevProps.downloadSource.modified !== this.props.downloadSource.modified) {
                this.updateProcessInfo();
            }
        }
        catch (error) { }
    }

    //Métodos operativos:
    modalToggle = () => {
        this.setState({ isTheModalOpen: !this.state.isTheModalOpen });
    }

    updateProcessInfo = () => {
        console.log(`updateProcessInfo this.props.targetProcess  ${this.props.targetProcess}`);
        if (this.props.targetProcess !== undefined) {
            fetch(process.env.REACT_APP_API_URL + "/process/" + this.props.targetProcess.id + "/detail/", {
                method: 'get',
                headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
            })
                .then(serverResponse => {
                    serverResponse.json()
                        .then(processDetail => {
                            if (JSON.stringify(this.state.processDetail) !== JSON.stringify(processDetail)) {
                                this.setState({ processDetail: processDetail });
                            }
                        })
                        .catch(error => console.log(error));
                })
                .catch(error => console.log(error));


            if (this.props.targetProcess.status === "SUCCESS" || this.props.targetProcess.status === "WARNING") {
                fetch(process.env.REACT_APP_API_URL + "/processes/" + this.props.targetProcess.id + "/get_file_info/", {
                    method: 'get',
                    headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
                })
                    .then(serverResponse => {
                        if (serverResponse.status === 200) {
                            serverResponse.json()
                                .then(filesDetail => {
                                    if (JSON.stringify(this.state.filesDetail) !== JSON.stringify(filesDetail)) {
                                        this.setState({ filesDetail: filesDetail });
                                    }
                                });
                        }

                        if (serverResponse.status === 400) {
                            serverResponse.json()
                                .then(fetchErrorDetail => {
                                    console.log(fetchErrorDetail);
                                });
                        }
                    })
                    .catch(error => { console.log(error) });
            }
        }
    }

    //Métodos para renderizado:
    getCancellationDateLabel = () => {
        if (this.props.targetProcess.status === "CANCELLED") {
            let endDate = new Date(this.props.targetProcess.end_date || this.props.targetProcess.modified);

            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Fecha de cancelación:</p>
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                        <b>{dateFormatter.getShortDate(endDate)}</b>
                        {", " + dateFormatter.getShortHour(endDate)}
                    </p>
                </React.Fragment>
            );
        }
    }

    getDownloadProgessBar = () => {
        if (this.props.targetProcess.status === "IN_PROCESS") {

            let progress = 0;

            // Check if there's progress from external bot status_detail (get the most recent one)
            const externalBotUpdates = this.state.processDetail.filter(
                step => step.name === "EXTERNAL_BOT_STATUS_UPDATE" && step.status_detail?.progress !== undefined
            );
            const externalBotUpdate = externalBotUpdates.length > 0 ? externalBotUpdates[externalBotUpdates.length - 1] : null;

            if (externalBotUpdate && externalBotUpdate.status_detail?.progress !== undefined) {
                // Use progress from external bot
                progress = externalBotUpdate.status_detail.progress;
            } else {
                // Fallback: Calculate progress from completed steps (for internal bots)
                let totalStepsForSuccessProccess = this.props.downloadSource.processes_detail_quantity || 5;
                let totalOfCompletedSteps = this.state.processDetail.filter(processStep => processStep.show_detail && processStep.status === 'SUCCESS').length - 1;

                progress = (totalOfCompletedSteps > 0) ? totalOfCompletedSteps * 100 / totalStepsForSuccessProccess : 0;
            }

            if (progress > 100) { progress = 100; }

            return (
                <React.Fragment>
                    <Progress animated striped color="success" value={progress} />
                    <Row>
                        <Col xs="10" sm="10" md="10" lg="10">
                            {/* <p className="category" style={{ textTransform: "none" }}
                                dangerouslySetInnerHTML={{ __html: "Termina en: --- minutos" }}>
                            </p> */}
                        </Col>

                        <Col xs="2" sm="2" md="2" lg="2">
                            <div className="text-right">
                                <p className="category" style={{ paddingRight: 5 }}>
                                    {Math.round(progress) + "%"}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </React.Fragment>
            );
        }
    }

    getElapsedTimeLabel = () => {
        if (this.props.targetProcess.status === "IN_PROCESS") {
            return (<ElapsedTimeLabel referenceDate={new Date(this.props.targetProcess.created)} />);
        }
    }

    getErrorDetailContainer = () => {
        if (this.props.targetProcess.status === "ERROR") {
            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Error:</p>
                    <p className="muted-text" style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.65em" }}>
                        {this.props.targetProcess.status_detail || "Error no identificado..."}
                    </p>
                </React.Fragment>
            );
        }
    }

    getFailedDownloadProgressBar = () => {
        if (this.props.targetProcess.status === "ERROR") {

            let totalStepsForSuccessProccess = this.props.downloadSource.processes_detail_quantity || 5;
            let totalOfCompletedSteps = this.state.processDetail.filter(processStep => processStep.show_detail && processStep.status === 'SUCCESS').length - 1;

            let progress = (totalOfCompletedSteps > 0) ? totalOfCompletedSteps * 100 / totalStepsForSuccessProccess : 0;
            if (progress >= 100) { progress = 75; }

            return (
                <React.Fragment>
                    <Progress striped color="danger" value={progress} />
                    <div className="text-right">
                        <p className="category" style={{ paddingRight: 5 }}>
                            {Math.round(progress) + "%"}
                        </p>
                    </div>
                </React.Fragment>
            );
        }
    }

    getFileDetailContainer = () => {
        if (this.props.targetProcess.status === "SUCCESS" || this.props.targetProcess.status === "WARNING") {
            if (this.state.filesDetail.length > 0) {

                let containerTitle = (this.state.filesDetail.length === 1) ? "Información del archivo:" :
                    ("Información de los <b>" + getNumberAsWord(this.state.filesDetail.length) + "</b> archivos:");

                return (
                    <React.Fragment>
                        <p style={paragraphBaseStyle} dangerouslySetInnerHTML={{ __html: containerTitle }} />
                        {this.state.filesDetail.map((fileDetail, i) => {
                            return (
                                <React.Fragment key={"fileDetail." + i + "." + (new Date()).getSeconds()}>
                                    {(i > 0) ? <hr /> : <React.Fragment />}
                                    <FileDetailBlock fileDetail={fileDetail} />
                                </React.Fragment>
                            );
                        })}
                    </React.Fragment>
                );
            }

        }
    }

    getFinishDateLabel = () => {
        if (this.props.targetProcess.status === "SUCCESS" || this.props.targetProcess.status === "WARNING") {
            let startDate = new Date(this.props.targetProcess.created);
            let endDate = new Date(this.props.targetProcess.end_date || this.props.targetProcess.modified);

            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Fecha de finalización:</p>
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                        <b>{dateFormatter.getShortDate(endDate)}</b>
                        {", " + dateFormatter.getShortHour(endDate) +
                            "   ( Tardó " + dateFormatter.getDatesInterval(startDate, endDate, false) + " )"}
                    </p>
                </React.Fragment>
            );
        }
    }

    getFooterButtonsBasedOnStatus = () => {
        let userCanClickTheButton = (false || this.props.activeUser.is_admin || this.props.activeUser.is_staff);
        let buttonsList = [];
        switch (this.props.targetProcess.status) {
            case "SUCCESS":
            case "WARNING":
                let getWarningButton = () =>{
                    return(
                        <FileButton color="success" key={"botonParaFooter.0"} userCanClickTheButton={userCanClickTheButton}
                        targetProcess={{ ...this.props.targetProcess, linkedDownloadSource: this.props.downloadSource }} />
                    )
                }
                buttonsList.push(getWarningButton());
                return buttonsList;
            case "WAITING_FOR_USER_ACTION":
            case "PAUSED":
            case "QUEUE_PENDING":
            case "IN_PROCESS":
                if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) {
                    let getCancellationButton = () => {
                        return (
                            <Button color="danger" key={"botonParaFooter.cancelButton"} disabled={!userCanClickTheButton}
                                onClick={() => { this.props.cancelDownloadProcess(this.props.targetProcess, this.props.downloadSource); }}>
                                Cancelar
                            </Button>
                        );
                    }

                    buttonsList.push(getCancellationButton());
                }
                return buttonsList;
            case "CANCELLED":
            case "ERROR":
                if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) {
                    // Add download button if allow_download_on_error is enabled (only for ERROR status)
                    if (this.props.targetProcess.status === "ERROR" &&
                        this.props.targetProcess?.whole_config?.allow_download_on_error === true) {
                        let getDownloadButton = () => {
                            return (
                                <FileButton color="success" key={"botonParaFooter.download"}
                                    userCanClickTheButton={userCanClickTheButton}
                                    targetProcess={{ ...this.props.targetProcess, linkedDownloadSource: this.props.downloadSource }} />
                            );
                        }
                        buttonsList.push(getDownloadButton());
                    }
                    let getRetryButton = () => {
                        return (
                            <Button color="primary" key={"botonParaFooter.retryButton"} disabled={!userCanClickTheButton}
                                onClick={() => { this.props.retryDownloadProcess(this.props.targetProcess, this.props.downloadSource); }}>
                                Reintentar
                            </Button>
                        );
                    }
                    buttonsList.push(getRetryButton());
                }
                return buttonsList;
            case "NEW":
                return [<Button color="primary" key={"botonParaFooter.newButton"} onClick={() => { }}>Ejecutar</Button>];
            default:
                return [];
        }

    }

    getModalTitleBasedOnStatus = () => {
        return (
            <p style={{ marginBottom: 5, textTransform: "capitalize" }}>
                <b>
                    {getSourceTitleText(this.props.downloadSource.description)}
                </b>
                <span style={{ textTransform: "none" }}>
                    {getSourceSubtitleText(this.props.downloadSource.description)}
                </span>
            </p>
        );
    }

    getRemainingTimeLabel = () => {
        if (this.props.targetProcess.status === "IN_PROCESS") {
            let stringConTiempoDeDiferencia = dateFormatter.getDatesInterval(new Date(), new Date(this.props.targetProcess.end_date));
            let stringConFechaEstimadaDeFinalizacion = dateFormatter.getShortDate(new Date(this.props.targetProcess.end_date))
                + ", " + dateFormatter.getShortHour(new Date(this.props.targetProcess.end_date));

            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Tiempo restante estimado:</p>
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}
                        dangerouslySetInnerHTML={{
                            __html:
                                stringConTiempoDeDiferencia + " [" + stringConFechaEstimadaDeFinalizacion + "]"
                        }}>
                    </p>
                </React.Fragment>
            );
        }
    }

    getSpentTimeBeforeErrorLabel = () => {
        if (this.props.targetProcess.status === "ERROR") {
            let stringConTiempoDeDiferencia = dateFormatter.getDatesInterval(new Date(this.props.targetProcess.created), new Date(this.props.targetProcess.end_date));
            stringConTiempoDeDiferencia += " (" + dateFormatter.getShortDate(new Date(this.props.targetProcess.end_date)) + ", " +
                dateFormatter.getShortHour(new Date(this.props.targetProcess.end_date)) + ")";

            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Tiempo transcurrido antes del error:</p>
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}
                        dangerouslySetInnerHTML={{ __html: stringConTiempoDeDiferencia }}></p>
                </React.Fragment>
            );
        }
    }

    getStartDateLabel = () => {
        return (
            <React.Fragment>
                <p style={paragraphBaseStyle}>Fecha de inicio:</p>
                <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                    <b>{dateFormatter.getShortDate(new Date(this.props.targetProcess.created))}</b>
                    {", " + dateFormatter.getShortHour(new Date(this.props.targetProcess.created))}
                </p>
            </React.Fragment>
        );
    }

    getVariableDetail = () => {
        if(this.props.targetProcess.whole_config.variables){
            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Variables Utilizadas:</p>
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                    {
                        this.props.targetProcess.whole_config.variables.map( variable => {
                            return (<span key={variable.name}><b>{variable.name}: </b>{variable.value}<br/></span>)
                        })
                    }
                    </p>
                </React.Fragment>
            );
        }
        
    }

    getProcessDetail = () => {
        //console.log(this.props.targetProcess)
        if("downloaded_files" in this.props.targetProcess.process_detail){
            const dowloadedFiles = this.props.targetProcess.process_detail.downloaded_files
            const input_file_index = this.props.targetProcess.process_detail.input_file_index
            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Estado del proceso:</p>

                    {
                        this.props.targetProcess.process_detail.input_file_index > 0 ?
                        <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                            <b>Registros de entrada procesados: </b>
                            {input_file_index <=0 ? input_file_index : input_file_index+1}
                        </p> : null
                    }
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                        <b>Archivos descargados: </b>
                        {(dowloadedFiles <=0 ? dowloadedFiles : dowloadedFiles+1)}
                    </p>
                    { this.props.targetProcess.process_detail.web_rows_processed >0 ?
                        <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                            <b>Registros web procesados: </b>
                            {(this.props.targetProcess.process_detail.web_rows_processed)}
                        </p> : null
                    }
                </React.Fragment>
            );
        }
    }

    getExternalBotMessage = () => {
        // Get the most recent external bot status update with a message
        const externalBotUpdates = this.state.processDetail.filter(
            step => step.name === "EXTERNAL_BOT_STATUS_UPDATE" && step.status_detail?.message
        );

        if (externalBotUpdates.length > 0) {
            const latestUpdate = externalBotUpdates[externalBotUpdates.length - 1];
            const statusDetail = latestUpdate.status_detail;

            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>Información del bot externo:</p>
                    <div
                        style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em", color: "#555" }}
                        dangerouslySetInnerHTML={{ __html: statusDetail.message }}
                    />
                </React.Fragment>
            );
        }
        return null;
    }

    getStatusDetailModal = () => {
        if (this.props.targetProcess !== undefined) {
            return (
                <CustomModal isTheModalOpen={this.state.isTheModalOpen} modalToggle={this.modalToggle}
                    title={this.getModalTitleBasedOnStatus()} footerButtons={this.getFooterButtonsBasedOnStatus()} >
                    <Row>
                        <Col xs="12" md="12" lg="7" xl="7" style={{ marginTop: 30, paddingLeft: 30, paddingRight: 30 }}>
                            <div>
                                <p style={paragraphBaseStyle}>
                                    {"Estado de la " + (this.props.context || "descarga") + ":"}
                                </p>
                                <div className="icon-big text-center icon-warning">
                                    <i className={this.props.getStatusIconClassname(this.props.targetProcess)} />
                                </div>

                                <p style={{ ...paragraphBaseStyle, ...oneLineParagraphBaseStyle, textAlign: "center" }}>
                                    <b>{this.props.getDownloadSourceTitle(this.props.targetProcess)}</b>
                                </p>

                                {this.getDownloadProgessBar()}
                                {this.getFailedDownloadProgressBar()}
                            </div>

                            <hr></hr>

                            <PerfectScrollbar style={{ paddingTop: 15, maxHeight: 240 }}>
                                {this.getWarningLabel()}
                                {this.getStartDateLabel()}
                                {this.getVariableDetail()}
                                {this.getProcessDetail()}
                                {this.getExternalBotMessage()}
                                {this.getFinishDateLabel()}
                                {this.getElapsedTimeLabel()}
                                {this.getCancellationDateLabel()}
                                {this.getSpentTimeBeforeErrorLabel()}
                                {this.getFileDetailContainer()}
                                {this.getErrorDetailContainer()}
                            </PerfectScrollbar>
                        </Col>

                        <Col xs="12" md="12" lg="5" xl="5" style={{ marginTop: 30 }}>
                            <Card style={{ backgroundColor: "#f5f3ef" }}>
                                <ProcessTimeline targetProcess={this.props.targetProcess} processDetail={this.state.processDetail}
                                    getTimelineDivClassname={this.props.getTimelineDivClassname} getTimelineIconClassname={this.props.getTimelineIconClassname} />
                            </Card>
                        </Col>
                    </Row>
                </CustomModal>
            );
        }
    }

    getWarningLabel = () => {
        if (this.props.targetProcess.status === "WARNING") {
            // let statusDetailAsList = this.props.targetProcess.status_detail.split("<br>");
            // let noRepeatedStatusDetailAsList = [...new Set(statusDetailAsList)];
            // console.log(noRepeatedStatusDetailAsList);

            return (
                <React.Fragment>
                    <p style={paragraphBaseStyle}>* Advertencias:</p>
                    <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}
                        dangerouslySetInnerHTML={{ __html: this.props.targetProcess.status_detail }}></p>
                </React.Fragment>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost
    };
};

export default connect(mapStateToProps)(ButtonWithStatusModal);